import { defineColumns } from '@juvare/platform-shared/features/storage';
export const licenseCheckLatestStatusListViewColumns = defineColumns({
    id: {
        type: 'id-required',
    },
    personId: {
        type: 'id-required',
    },
    occupationId: {
        type: 'id-required',
    },
    credentialId: {
        type: 'id-required',
    },
    jasBoard: {
        type: 'boolean-required',
    },
    licenseId: {
        type: 'id-required',
        index: 'unique',
    },
    status: {
        type: 'string-required',
    },
    personName: {
        type: 'string-required',
    },
    occupationName: {
        type: 'string-required',
    },
    occupationGroupId: {
        type: 'id-required',
    },
    requestDate: {
        type: 'number',
    },
    requestedBy: {
        type: 'string',
    },
    credentialName: {
        type: 'string-required',
    },
    search: {
        type: 'full-text-search-required',
        language: 'english',
    },
    city: {
        type: 'string',
    },
    state: {
        type: 'string',
    },
    county: {
        type: 'string',
    },
    tribe: {
        type: 'string',
    },
    tribeId: {
        type: 'string',
    },
    ecls: {
        type: 'string-array',
    },
    personSystemStatus: {
        type: 'string',
    },
});
export const licenseCheckLatestStatusListViewName = 'licenseCheckLatestStatusViewList';
